import { render, staticRenderFns } from "./TenantDomains.vue?vue&type=template&id=29b01495"
import script from "./TenantDomains.vue?vue&type=script&lang=js"
export * from "./TenantDomains.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports